import { render, staticRenderFns } from "./ArticleStatus.vue?vue&type=template&id=6f8b12a9&"
import script from "./ArticleStatus.vue?vue&type=script&lang=js&"
export * from "./ArticleStatus.vue?vue&type=script&lang=js&"
import style0 from "./ArticleStatus.vue?vue&type=style&index=0&id=6f8b12a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports